import React from "react"
import { Link } from "gatsby"

const AiScreenCta = () => (
  <div className="ai-screen-cta">
    <p className="ai-screen-kicker">Hiring? Don't take a résumé's word for it.</p>
    <h3 className="ai-screen-title">
      Let your AI screen me — <span>objectively.</span>
    </h3>
    <p className="ai-screen-sub">
      Paste your role, copy one self-contained prompt with my full profile baked in, and
      drop it into ChatGPT, Claude, or Gemini. It scores the fit — no sign-up, no install,
      works in any AI.
    </p>
    <div className="ai-screen-actions">
      <Link to="/hire" className="btn ai-screen-btn">
        Screen me with your AI →
      </Link>
      <Link to="/for-ai" className="ai-screen-link">
        or connect your agent →
      </Link>
    </div>
  </div>
)

export default AiScreenCta
